import React from "react";
import {Divider, Form, Input, Select} from "antd";
import companyValidation from "../companyValidation";
import FormInput from "../../../components/FormInput/FormInput";
import {phonePrefixes} from "../../../constants/phonePrefixes";

const {Option} = Select;

const SecondStepRepresentative = ({darkMode}) => {

    return <>
        <Divider orientation="left">Responsible Person</Divider>

        <FormInput placeholder="John Doe" label='Representative Full Name' name='representativeFullName'
                   rules={companyValidation.representativeFullName}/>
        <FormInput placeholder="john.doe@mail.com" label='Email' name='email' rules={companyValidation.email}
                   tooltip='Email to which the activation code will be sent'/>

        <Form.Item
            name={['telephone', "number"]}
            label={`Phone Number`}
            rules={companyValidation.telephone}
        >
            <Input
                placeholder="65333444"
                addonBefore={
                    <Form.Item
                        name={['telephone', "areaCode"]}
                        noStyle
                        initialValue={phonePrefixes[0]}
                    >
                        <Select dropdownClassName={darkMode && 'dark-mode'}>
                            {phonePrefixes.map(prefix => <Option key={prefix} value={prefix}>{prefix}</Option>)}
                        </Select>
                    </Form.Item>
                }
            />
        </Form.Item>

    </>;
};

export default SecondStepRepresentative;